import { atom } from "recoil";
import { v4 } from "uuid";

import { IFormInput } from "global-states";
import { ISignupScreenState } from "./types";
import { SIGNUP_FORM } from "../constants";

export const IsTermAndConditionCheckedState = atom({
  key: v4(),
  default: false,
});

export const SignUpScreenState = atom<ISignupScreenState | undefined>({
  key: v4(),
  default: undefined,
});

export const SignUpCurrentModalState = atom<string | undefined>({
  key: v4(),
  default: "",
});

export const CreateUserRespState = atom<{ [key: string]: string }>({
  key: v4(),
  default: {},
});

export const SignUpFormInputsState = atom<IFormInput[]>({
  key: v4(),
  default: SIGNUP_FORM,
});

export const CurrentMethodState = atom({
  key: v4(),
  default: "",
});
